export default "__VITE_ASSET__CJgj8SEy__"